import { useAppStateContext } from "@contexts/app"
import React from "react"
import { Helmet } from "react-helmet"

export default function Title() {
    const { title } = useAppStateContext()

    return (
        <React.Fragment>
            <Helmet>
                <title>{title}</title>
            </Helmet>
        </React.Fragment>
    )
}
